module.exports = __webpack_public_path__ + "static/media/pic_1.03400a86.jpg";